export default "__VITE_ASSET__jiTCUOv9__"